__webpack_require__.p = "/animal-crossing-dex/";